/*import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app') */

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import 'leaflet/dist/leaflet.css';
import { Icon }  from 'leaflet'
delete Icon.Default.prototype._getIconUrl;


import Slideout from '@hyjiacan/vue-slideout'
import '@hyjiacan/vue-slideout/lib/slideout.css'


Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

import store from './store/store';

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));
Vue.use(Slideout);

new Vue({
  vuetify,
  store,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  render: h => h(App)
}).$mount('#app')


/*import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'

const app = createApp(App)
app.use(vuetify)

app.mount('#app')
*/